import request from '@/utils/request';
import { AjaxMethod } from '@/utils/dataMap';

// 货盘列表
export const palletList = params => {
	return request({
		url: '/api/product-pallet/list/',
		data: params,
		method: AjaxMethod.post,
	});
};

// 导入货盘
export const importPallet = params => {
	return request({
		url: '/api/product-pallet/import/',
		data: params,
		method: AjaxMethod.post,
	});
};

// 导出货盘
export const exprotPallet = (params, notOrigin = true) => {
	return request({
		url: '/api/product-pallet/export-product-pallet/',
		params,
		method: AjaxMethod.get,
		notOrigin,
	});
};

// 导出失败的货盘
export const exprotFailPallet = (params, notOrigin = true) => {
	return request({
		url: '/api/product-pallet/export-fail-product/',
		params,
		method: AjaxMethod.get,
		notOrigin,
	});
};

// 添加货盘联系人
export const addPalletContact = params => {
	return request({
		url: '/api/product-pallet/add-contact/',
		data: params,
		method: AjaxMethod.post,
	});
};

// 货盘联系人列表
export const palletContactList = (params, notOrigin = true) => {
	return request({
		url: '/api/product-pallet/contact-list',
		params: params,
		method: AjaxMethod.get,
		notOrigin,
	});
};

//修改备注接口
export const saveRemark = params => {
	return request({
		url: '/api/product-pallet/save-remark/',
		params: params,
		method: AjaxMethod.get,
	});
};

//编辑商品机制
export const editProduct = params => {
	return request({
		url: '/api/product-info/edit-product/',
		data: params,
		method: AjaxMethod.post,
	});
};

//获取商品库列表
export const productList = params => {
	return request({
		url: '/api/product-info/list',
		data: params,
		method: AjaxMethod.post,
		notOrigin: true,
	});
};

//编辑商品个别字段
export const editField = params => {
	return request({
		url: '/api/product-info/edit-product-field',
		data: params,
		method: AjaxMethod.post,
	});
};

//获取商品组列表
export const groupList = params => {
	return request({
		url: '/api/product-group/list',
		data: params,
		method: AjaxMethod.post,
	});
};

//修改商品推广状态
export const infoStatus = params => {
	return request({
		url: '/api/product-info/set-status',
		data: params,
		method: AjaxMethod.post,
	});
};

//修改商品组状态
export const groupStatus = params => {
	return request({
		url: '/api/product-group/set-status',
		data: params,
		method: AjaxMethod.post,
	});
};

//加入商品组
export const joinGroup = params => {
	return request({
		url: '/api/product-group/join-group',
		data: params,
		method: AjaxMethod.post,
	});
};

//创建商品组
export const createGroup = params => {
	return request({
		url: '/api/product-group/add-group',
		data: params,
		method: AjaxMethod.post,
	});
};

//商品组商品列表
export const shopGroupList = params => {
	return request({
		url: '/api/product-group/group-product-list',
		data: params,
		method: AjaxMethod.post,
	});
};

//商品详情列表
export const shopDetail = params => {
	return request({
		url: '/api/product-info/product-detail/',
		params: params,
		method: AjaxMethod.get,
	});
};

//商品组详情
export const shopGroupDetail = params => {
	return request({
		url: '/api/product-group/detail',
		data: params,
		method: AjaxMethod.post,
	});
};

//从商品组移除
export const removeGroup = params => {
	return request({
		url: '/api/product-group/remove-group',
		data: params,
		method: AjaxMethod.post,
	});
};

//商品组下拉列表
export const selectList = params => {
	return request({
		url: '/api/product-group/select-list',
		data: params,
		method: AjaxMethod.post,
	});
};

//商品组下拉列表
export const cateList = params => {
	return request({
		url: '/api/product-info/cate-list',
		params: params,
		method: AjaxMethod.get,
	});
};

//商品组创建人列表
export const creatUserList = params => {
	return request({
		url: '/api/product-group/creat-user-list',
		data: params,
		method: AjaxMethod.post,
	});
};

//校验是否绑定机构
export const checkAuthorize = (params, notOrigin = true) => {
	return request({
		url: '/api/institution/check-authorize',
		data: params,
		method: AjaxMethod.post,
		notOrigin,
	});
};

//同步接口
export const colonelActivity = params => {
	return request({
		url: '/api/activity/sync-colonel-activity',
		data: params,
		method: AjaxMethod.post,
	});
};

//同步商品接口
export const syncProduct = params => {
	return request({
		url: '/api/product-info/sync-product',
		data: params,
		method: AjaxMethod.post,
	});
};
//同步商品 根据团长 获取 店铺名称
export const apiSpShopList = params => {
	return request({
		url: '/product/partner/shop/sph-shop-list',
		params,
		method: AjaxMethod.get,
	});
};
//同步商品 根据活动id或名称 拉取活动列表
export const syncActivityList = params => {
	return request({
		url: '/api/activity/my-activity-search',
		data: params,
		method: AjaxMethod.post,
	});
};
//同步商品 根据活动id 拉取商品列表 抖音
export const syncProductList = params => {
	return request({
		url: '/api/activity/product-list',
		data: params,
		method: AjaxMethod.post,
	});
};
//同步商品 根据店铺 拉取商品列表 视频号
export const syncProductListSp = params => {
	return request({
		url: '/api/activity/product-list-sph',
		params: params,
		method: AjaxMethod.get,
	});
};

//同步接口
export const orderList = params => {
	return request({
		url: '/api/order/list',
		data: params,
		method: AjaxMethod.post,
	});
};

//待认领商品列表
export const claimList = (params, notOrigin = true) => {
	return request({
		url: '/api/product-info/claim-list',
		data: params,
		method: AjaxMethod.post,
		notOrigin,
	});
};

//分配
export const productAllot = params => {
	return request({
		url: '/api/product-info/product-allot',
		data: params,
		method: AjaxMethod.post,
	});
};

//认领
export const productReceive = params => {
	return request({
		url: '/api/product-info/product-receive',
		data: params,
		method: AjaxMethod.post,
	});
};

//添加到申样表
export const addProduct = params => {
	return request({
		url: '/api/anchor-product/add-product',
		data: params,
		method: AjaxMethod.post,
	});
};

//检查是否申样
export const checkAdd = params => {
	return request({
		url: '/api/sample-order/check-add',
		data: params,
		method: AjaxMethod.post,
	});
};

//删除商品组
export const delGroup = params => {
	return request({
		url: '/api/product-group/delete',
		data: params,
		method: AjaxMethod.post,
	});
};

//商品删除
export const delProduct = params => {
	return request({
		url: '/api/product-info/del',
		data: params,
		method: AjaxMethod.post,
	});
};

//获取商品库回收站列表
export const wasteList = params => {
	return request({
		url: '/api/recycle/product-list/',
		params: params,
		method: AjaxMethod.get,
	});
};

//恢复删商品
export const restoreProduct = params => {
	return request({
		url: '/api/recycle/restore-product',
		params: params,
		method: AjaxMethod.get,
	});
};

//删除货盘
export const delPallet = params => {
	return request({
		url: '/api/product-pallet/del-pallet',
		params: params,
		method: AjaxMethod.get,
	});
};

//获取转链链接
export const getSourceUrl = params => {
	return request({
		url: 'api/product-info/get-pick-source-url',
		params: params,
		method: AjaxMethod.get,
	});
};

// 订单统计金额
export const orderStatistics = params => {
	return request({
		url: '/api/order/statistics',
		params: params,
		method: AjaxMethod.get,
	});
};
// 达人商务未认领订单金额
export const talentStatistics = params => {
	return request({
		url: '/api/order/statistics-talent',
		params: params,
		method: AjaxMethod.get,
	});
};
// 招商运营未认领订单金额
export const bdStatistics = params => {
	return request({
		url: '/api/order/statistics-bd',
		params: params,
		method: AjaxMethod.get,
	});
};

//订单分配
export const orderAllocation = params => {
	return request({
		url: '/api/order/allocation',
		params: params,
		method: AjaxMethod.get,
	});
};

//设置分成比
export const setRate = data => {
	return request({
		url: '/api/partner-rate/set-rate',
		data,
		method: AjaxMethod.post,
	});
};

//商品库公开分享
export const shareLib = params => {
	return request({
		url: '/api/product-info/share-product-lib',
		data: params,
		method: AjaxMethod.post,
	});
};

//商品库公开分享
export const exportOrder = params => {
	return request({
		url: '/api/order/export',
		data: params,
		method: AjaxMethod.post,
	});
};

//订单导出列表
export const exportOrderList = params => {
	return request({
		url: '/api/export/order-list',
		data: params,
		method: AjaxMethod.post,
	});
};

// 商品库列表取消认领
export const cancelReceive = data => {
	return request({
		url: '/api/product-info/cancel-receive',
		data,
		method: AjaxMethod.post,
	});
};

// 管理员重新分配
export const againAllot = data => {
	return request({
		url: '/api/product-info/again-allot',
		data,
		method: AjaxMethod.post,
	});
};

//修改货盘联系人
export const udpContact = data => {
	return request({
		url: '/api/product-pallet/udp-contact',
		data,
		method: AjaxMethod.post,
	});
};

// 订单操作记录
export const getBelongList = params => {
	return request({
		url: '/api/order/belong-list',
		params,
		method: AjaxMethod.get,
	});
};

// 批量修改订单归属-同步执行
export const updateOrderBatchBelong = data => {
	return request({
		url: '/api/order/order-batch-belong',
		data,
		method: AjaxMethod.post,
	});
};

// 批量修改订单归属-同步执行
export const updateOrderSearchBelong = data => {
	return request({
		url: '/api/order/order-search-belong',
		data,
		method: AjaxMethod.post,
	});
};

// 获取单个达人分成信息
export const getPartnerRate = params => {
	return request({
		url: '/api/partner/get-rate',
		params,
		method: AjaxMethod.get,
	});
};

// 批量申样
export const directBatchAdd = data => {
	return request({
		url: '/api/sample-order/direct-batch-add',
		data,
		method: AjaxMethod.post,
	});
};

// 设置招商运营提成比
export const setMerchantsRate = data => {
	return request({
		url: '/api/partner-rate/set-merchants-rate',
		data,
		method: AjaxMethod.post,
	});
};

// 异常订单统计
export const getAbnormalTotal = params => {
	return request({
		url: '/api/order/attribution-abnormal',
		params,
		method: AjaxMethod.get,
	});
};

//验证是否可以申样
export const checkSendSampleOrder = data => {
	return request({
		url: '/api/second-institution-anchor/check-send-sample-order',
		data,
		method: AjaxMethod.post,
	});
};

// 商品导出
export const productInfoExport = data => {
	return request({
		url: '/api/product-info/export',
		data,
		method: AjaxMethod.post,
	});
};

// 全部商品
export const allProductList = data => {
	return request({
		url: '/api/product-info/all-product-list',
		data,
		method: AjaxMethod.post,
	});
};

// 选品中心分享记录
export const shareSelectCenter = data => {
	return request({
		url: '/api/product-group/share-select-center',
		data,
		method: AjaxMethod.post,
	});
};

// 标签列表
export const tagsList = data => {
	return request({
		url: '/api/tags/list',
		data,
		method: AjaxMethod.post,
	});
};

export const upShareProduct = data => {
	return request({
		url: '/api/product-group/up-share-product',
		data,
		method: AjaxMethod.post,
	});
};

// 删除标签
export const delTags = data => {
	return request({
		url: '/api/tags/del-tags',
		data,
		method: AjaxMethod.post,
	});
};

// 新增编辑标签
export const setTags = data => {
	return request({
		url: '/api/tags/set-tags',
		data,
		method: AjaxMethod.post,
	});
};

// 设置单个商品标签(新增/编辑)
export const setProductTags = data => {
	return request({
		url: '/api/tags/set-product-tags',
		data,
		method: AjaxMethod.post,
		notOrigin: true,
	});
};

// 多个商品新增标签
export const setProductTag = data => {
	return request({
		url: '/api/tags/set-products-tag',
		data,
		method: AjaxMethod.post,
		notOrigin: true,
	});
};

// 多个商品置顶
export const setProductTop = data => {
	return request({
		url: '/api/product-info/set-top',
		data,
		method: AjaxMethod.post,
	});
};

// 多个商品取消置顶
export const delProductTop = data => {
	return request({
		url: '/api/product-info/del-top',
		data,
		method: AjaxMethod.post,
	});
};
//分配记录列表获取 (接口待定)
export const allocatedOrderList = params => {
	return request({
		url: '/api/export/order-list',
		data: params,
		method: AjaxMethod.post,
	});
};
//托管商品列表查询接口
export const trusteeshipList = params => {
	return request({
		url: '/api/product-trusteeship/list',
		data: params,
		method: AjaxMethod.post,
	});
};
//同步拉取商品库活动商品
export const pullBusinessGoods = params => {
	const api = process.env.VUE_APP_API_BASE === 'https://test-partner-api' ? '/micro-product-center' : '/micro-product-center-canary';
	return request({
		url: `${api}/sync/business`,
		data: params,
		method: AjaxMethod.post,
		notOrigin: true,
	});
};
//同步拉取托管商品
export const pullTrusteeshipGoods = params => {
	return request({
		url: '/micro-product-center/sync/business',
		data: params,
		method: AjaxMethod.post,
		notOrigin: true,
	});
};
//查询是否有任务正在执行
export const pullSyncStatus = params => {
	const api = process.env.VUE_APP_API_BASE === 'https://test-partner-api' ? '/micro-product-center' : '/micro-product-center-canary';
	return request({
		url: `${api}/sync/status`,
		data: params,
		method: AjaxMethod.post,
		notOrigin: true,
	});
};
//查询任务同步状态
export const taskProgressInfo = params => {
	return request({
		url: '/micro-user/task/progress-list',
		data: params,
		method: AjaxMethod.post,
	});
};
//托管商品认领接口
export const trusteeshipClaims = params => {
	return request({
		url: '/api/product-trusteeship/claims',
		data: params,
		method: AjaxMethod.post,
	});
};
//托管商品审核接口
export const trusteeshipApply = params => {
	return request({
		url: '/api/product-trusteeship/apply',
		data: params,
		method: AjaxMethod.post,
	});
};
//托管商品分配接口
export const trusteeshipDistribution = params => {
	return request({
		url: '/api/product-trusteeship/distribution',
		data: params,
		method: AjaxMethod.post,
	});
};
//托管商品-最近一次同步时间接口
export const trusteeshipSyntime = data => {
	return request({
		url: '/micro-product-center/sync/status',
		data,
		method: AjaxMethod.post,
		notOrigin: true,
	});
};
//查询商品手卡
export const getHandcard = params => {
	return request({
		url: '/api/product-info/get-handcard',
		params,
		method: AjaxMethod.get,
		notOrigin: true,
	});
};
//查询商品手卡
export const setHandcard = data => {
	return request({
		url: '/api/product-info/set-handcard',
		data,
		method: AjaxMethod.post,
		notOrigin: true,
	});
};
//预览商品系统手卡
export const previewHandcard = data => {
	return request({
		url: '/api/product-info/preview-handcard',
		data,
		method: AjaxMethod.post,
		notOrigin: true,
	});
};

//延长推广时间
export const delayPromotion = data => {
	return request({
		url: '/api/promo-ext-records/create',
		data,
		method: AjaxMethod.post,
		notOrigin: true,
	});
};

//延长推广记录
export const promoRecordsList = params => {
	return request({
		url: '/api/promo-ext-records/detail',
		params,
		method: AjaxMethod.get,
		notOrigin: true,
	});
};

//获取sku列表
export const getProductSkuList = data => {
	return request({
		url: '/api/product-info/get-sku-list',
		data,
		method: AjaxMethod.post,
		notOrigin: true,
	});
};

//sku同步接口
export const syncProductSkuList = data => {
	return request({
		url: '/micro-cyt/product-sku/sync',
		data,
		method: AjaxMethod.post,
		notOrigin: true,
	});
};

//单个获取sku列表
export const getProductSkuListOne = data => {
	return request({
		url: '/api/product-info/get-sku-list-by-product-id',
		data,
		method: AjaxMethod.post,
		notOrigin: true,
	});
};

//获取达人列表
export const selectListPage = data => {
	return request({
		url: '/api/talent/select-list-page',
		data,
		method: AjaxMethod.post,
		notOrigin: true,
	});
};

//商品公海
export const productCommonList = data => {
	return request({
		url: '/api/product-common/list',
		data,
		method: AjaxMethod.post,
	});
};

// 报名活动
export const productAdd = data => {
	return request({
		url: '/api/apply-product/apply',
		data,
		method: AjaxMethod.post,
	});
};

// 我的推广
export const applyProductList = data => {
	return request({
		url: '/api/apply-product/list',
		data,
		method: AjaxMethod.post,
	});
};

// 商品公海-商品类目
export const commonCategory = data => {
	return request({
		url: '/api/product-common/category',
		data,
		method: AjaxMethod.post,
	});
};

// 团长重复合作校验
export const tzDuplicateCooperationVerification = data => {
	return request({
		url: '/api/waiting-live/check-institute-nosample',
		data,
		method: AjaxMethod.post,
	});
};

// 达人重复合作校验
export const drDuplicateCooperationVerification = data => {
	return request({
		url: '/api/waiting-live/check-anchor-nosample',
		data,
		method: AjaxMethod.post,
	});
};

// 批量无样开播
export const batchBroadcastingWithoutSamples = data => {
	return request({
		url: '/api/waiting-live/batch-no-sample-live',
		data,
		method: AjaxMethod.post,
	});
};

// 批量延迟推广预览列表
export const batchDelayPreviewList = data => {
	return request({
		url: '/api/promo-ext-records/batch-create-preview',
		data,
		method: AjaxMethod.post,
	});
};

// 创建批量延迟推广任务
export const recordsBatchCreate = data => {
	return request({
		url: '/api/promo-ext-records/batch-create',
		data,
		method: AjaxMethod.post,
	});
};

// 商品流转记录-列表
export const productClaimLogList = params => {
	return request({
		url: '/api/product-claim/list',
		params,
		method: AjaxMethod.get,
	});
};

// 商品库 关联素材

// 商品批量添加素材
export const batchAddMaterial = data => {
	return request({
		url: '/api/product-material/batch-add-material',
		data,
		method: AjaxMethod.post,
		notOrigin: true,
	});
};

// 单个商品获取素材详情
export const gettMaterial = params => {
	return request({
		url: '/api/product-material/get-material-detail',
		params,
		method: AjaxMethod.get,
		notOrigin: true,
	});
};

//单个商品修改素材
export const editMaterialInfo = data => {
	return request({
		url: '/api/product-material/edit-material',
		data,
		method: AjaxMethod.post,
		notOrigin: true,
	});
};

//素材页面获取商品信息接口
export const materialProductList = data => {
	return request({
		url: '/api/product-info/get-material-product-list',
		data,
		method: AjaxMethod.post,
		notOrigin: true,
	});
};
// 关联素材添加商品抽屉接口
export const searchProductList = params => {
	return request({
		url: '/api/product-info/search-product-list',
		params,
		method: AjaxMethod.get,
		notOrigin: true,
	});
};

// 商品库 商品流转

// 检测分配店铺新对接人
export const getNewShopUser = data => {
	return request({
		url: '/api/cooperative-shop/check-shop-claim-user',
		data,
		method: AjaxMethod.post,
	});
};

// 商品流转记录-导出
export const exportGoodsFlowRecord = params => {
	return request({
		url: '/api/product-claim/export',
		params,
		method: AjaxMethod.get,
	});
};

// 商品流转记录上报
export const productClaimLogReport = data => {
	return request({
		url: '/api/product-claim/report',
		data,
		method: AjaxMethod.post,
		notOrigin: true,
	});
};

// 获取商品流转记录是否有记录
export const getProductClaimLogRecord = data => {
	return request({
		url: '/api/product-claim/tips',
		data,
		method: AjaxMethod.post,
		notOrigin: true,
	});
};

// 获取店铺评分接口
export const shopScores = data => {
	return request({
		url: '/micro-cyt/shop-info/shop-score',
		data,
		method: AjaxMethod.post,
		notOrigin: true,
	});
};

// 获取店铺列表
export const getShopList = data => {
	return request({
		url: '/api/product-info/search-shop-name',
		data,
		method: AjaxMethod.post,
		notOrigin: true,
	});
};

//视频号订单列表 https://www.eolink.com/share/inside/ebd79f046abe6ac1309b544925b16121/api/54419681/detail/54419681
export const getSpOrderList = params => {
	return request({
		url: '/trade-api-v1/trade-partner/sph-order/list',
		data: params,
		method: AjaxMethod.post,
	});
};

// 视频号订单统计  https://www.eolink.com/share/inside/8120e1e00b9cb0ade8eb5b6b5c875969/api/54419687/detail/54419687
export const getSpOrderStatistics = params => {
	return request({
		url: '/trade-api-v1/trade-partner/sph-order/statistics',
		data: params,
		method: AjaxMethod.post,
	});
};

// 勾选订单同步批量归属  https://www.eolink.com/share/inside/b54755ab4e6d614e6fa78fe39bf32f6f/api/54419691/detail/54419691
export const batchBelongBySelectSp = data => {
	return request({
		url: '/trade-api-v1/trade-partner/sph-order/batch-sync-belong',
		data,
		method: AjaxMethod.post,
	});
};

// 视频号订单批量异步归属 https://www.eolink.com/share/index?shareCode=3df242d0c23259f5c64a1aedf5d048f0&apiID=54419689&groupID=54419689
export const batchbelongBySearchSp = data => {
	return request({
		url: '/trade-api-v1/trade-partner/sph-order/batch-async-belong',
		data,
		method: AjaxMethod.post,
	});
};

// 订单列表导出  https://www.eolink.com/share/index?shareCode=5177e147cb2f74691a8e8e15fc8fe24c&apiID=54419686&groupID=54419686
export const exportOrderSp = data => {
	return request({
		url: '/trade-api-v1/trade-partner/sph-order/export',
		data,
		method: AjaxMethod.post,
	});
};
//webp格式图片上传转化为jpg格式
export const convertImgApi = data => {
	return request({
		url: '/product/partner/image/convert',
		data,
		method: AjaxMethod.post,
	});
};
// 类目接口 - 一级类目
export const actCategoryList = params => {
	return request({
		url: '/product/partner/category/list',
		params,
		method: AjaxMethod.get,
	});
};

// 获取二级类目
export const getCategoryList = params => {
	return request({
		url: '/product/partner/category/list-v1',
		params,
		method: AjaxMethod.get,
	});
};

// 达人类目列表
export const talCategoryList = params => {
	return request({
		url: '/product/partner/category/author-category-list',
		params: params,
		method: AjaxMethod.get,
	});
};

//获取活动商品分享口令
export const getProductShareToken = params => {
	return request({
		url: '/api/activity-ks/get-product-share-token',
		params,
		method: AjaxMethod.get,
	});
};

// 查看佣金列表
export const getCommissionList = data => {
	return request({
		url: '/api/product-info/commission-plans',
		data,
		method: AjaxMethod.post,
	});
};

// 同步佣金计划
export const syncCommissionPlan = data => {
	return request({
		url: '/micro-product-center/sync/sync-product-plan',
		data,
		method: AjaxMethod.post,
	});
};

// 添加佣金计划
export const addCommissionPlan = data => {
	return request({
		url: '/micro-product-center/sync/add-product-plan',
		data,
		method: AjaxMethod.post,
	});
};

// 缓存插件需要获取双佣金信息的商品
export const cacheDoubleCommissionProducts = data => {
	return request({
		url: '/api/product-info/launch-commission-rate',
		data,
		method: AjaxMethod.post,
	});
};